import React, { Component } from 'react';
import compose from 'recompose/compose';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import {
	setUploadReceiptListNew,
	uploadDecodeTargetNew,
	changeCurrentPath,
	resetUploadReceiptStateNew,
} from '../../actions';
import classNames from 'classnames';
import Dropzone from 'react-dropzone'
import _ from 'lodash';

import {getValueArray} from '../../common/utils/array';
import {getFileSize} from '../../common/utils/files';

import Header from '../../common/containers/header';
import Progress from '../../common/containers/progress'
import SpNav from '../../common/containers/sp_nav'
import Footer from '../../common/containers/footer';
import MainButtons from '../../common/components/main-buttons';

import ErrorDialog from '../../common/components/dialog/error-dialog';
import ReloadModal from '../../common/components/dialog/reload-dialog';
import AlertDialog from '../../common/components/dialog/alert-dialog';
import LogoutModal from '../../common/components/dialog/logout-dialog';

import SuccessDialog from './components/success-dialog';

import Button from '@material-ui/core/Button';
import red from '@material-ui/core/colors/red';



const styles = theme => ({
	abortButton:{
		backgroundColor:red[500],
		'&:hover': {
			backgroundColor: red[800],
		},
		color: theme.palette.getContrastText(red[500]),
	},
	cautionText:{
		marginTop:-10
	}
});


const maxFileSize = 100 * 1000 * 1000;
const totalMaxFileSize = 250 * 1000 * 1000;
const maxFileCount = 20;


class UploadReceiptNew extends Component {
	
	constructor(props) {
		super(props);
		this.state = {
			dragging : false,
			uploadList : [],
			errorList : [],
			isErrorOpen : false,
			dialogOpen:false,
			dialogFunc:undefined
		}
	}
	/** override methods **/
	
	componentDidMount() {
		const { dispatch, history } = this.props;
		window.scrollTo(0, 0);
		dispatch(changeCurrentPath({ currentPath: history.location.pathname }));
	}
	
	componentWillUnmount(){
		const { dispatch } = this.props;
		dispatch(resetUploadReceiptStateNew());
	}
	
	/** event handlers **/
	_handleDrop() {
		this.setState({
			dragging:false
		});
	}
	
	_handleDragOver(e) {}
	
	_handleDragEnter(e) {
		this.setState({
			dragging:true
		});
	}
	
	_handleDragLeave(e) {
		this.setState({
			dragging:false
		})
	}
	
	_handleDropAccepted(files) {
		const {dispatch,settings} = this.props;
		let lastFileManageNO = settings.lastFileManageNO;
		let totalFileSize = settings.totalFileSize;
		let totalFileCount = settings.totalFileCount;
		let uploadList = getValueArray(settings.uploadList);
		files.forEach((file,index)=>{
			const fileManageNO = lastFileManageNO+index+1;
			if(totalMaxFileSize <= totalFileSize + file.size){
				uploadList.push({
					STATUS:'NG',
					FILE_MANAGE_NO:fileManageNO,
					FILES:file,
					MSG:"合計"+getFileSize(totalMaxFileSize)+"まで同時UPLOAD可能"
				});
			}
			else if(totalFileCount >= maxFileCount){
				uploadList.push({
					STATUS:'NG',
					FILE_MANAGE_NO:fileManageNO,
					FILES:file,
					MSG:"合計"+maxFileCount+"点まで同時UPLOAD可能"
				});
			}
			else{
				uploadList.push({
					STATUS:'OK',
					FILE_MANAGE_NO:fileManageNO,
					FILES:file,
					MSG:''
				});
				totalFileSize += file.size;
				totalFileCount ++;
			}

		});
		lastFileManageNO += files.length + 1;

		dispatch(setUploadReceiptListNew({uploadList,lastFileManageNO,totalFileSize,totalFileCount}))
	}
	
	
	_handleDropRejected(files) {
		const {dispatch, settings} = this.props;
		let lastFileManageNO = settings.lastFileManageNO;
		let uploadList = getValueArray(settings.uploadList);

		files.forEach((file,index)=>{
			const fileManageNO = lastFileManageNO+index+1;

			const msg = (file.size > maxFileSize) ? getFileSize(maxFileSize) + "までのファイルのみUPLOAD可能" : "PDF形式のみアップロード可能";

			uploadList.push({
				STATUS:'NG',
				FILE_MANAGE_NO:fileManageNO,
				FILES:file,
				MSG:msg
			});
		});
		lastFileManageNO += files.length + 1;
		dispatch(setUploadReceiptListNew({uploadList,lastFileManageNO}))
	}
	
	_onClickDeleteFile(fileManageNO){
		const {dispatch, settings} = this.props;
		let uploadList = getValueArray(settings.uploadList);
		_.remove(uploadList, function(list) { return list["FILE_MANAGE_NO"] === fileManageNO; });

		const okFileInfo = this.getOkFileTotalInfo(uploadList);

		dispatch(setUploadReceiptListNew({uploadList,totalFileSize:okFileInfo.totalFileSize,totalFileCount:okFileInfo.totalFileCount}))
	}
	
	handleClickSave = event =>{
		const {dispatch,settings,auth} = this.props;
		const uploadList = getValueArray(settings.uploadList);
		let OkList = [];
		uploadList.forEach(item=>{
			if(item.STATUS === 'OK'){
				OkList.push(item.FILES);
			}
		});
		dispatch(uploadDecodeTargetNew({
			files:OkList,
			SessionID : auth.SessionID
		}))
	};


	handleCancelDialog = () =>{
		this.setState({
			dialogOpen:false
		});

	};

	handleCancelProcess = () =>{
		const {dispatch} = this.props;
		dispatch(resetUploadReceiptStateNew());

	};


	handleClickBack = event => {
		const OKList = _.filter(this.props.settings.uploadList,(item)=>{
			return _.includes(item.STATUS, 'OK');
		});

		if(OKList.length){
			this.setState({
				dialogOpen:true,
				dialogFunc:'BACK'

			})
		}
		else{
			this.props.history.push('/consignee-list-new');
		}
	};

	handleDoAfterDialog = event =>{
		if(this.state.dialogFunc === 'BACK'){
			this.props.history.push('/consignee-list-new');
		}
		else{

		}
	};

	handleCompleteProcess = () =>{
		const {dispatch,history} = this.props;
		dispatch(resetUploadReceiptStateNew());
		history.push('/consignee-list-new');
	};

	getOkFileTotalInfo = (source) =>{
		let totalFileSize = 0;
		let totalFileCount = 0;
		source.forEach((file,index) =>{
			if(file.STATUS === "OK"){
				totalFileSize += file.FILES.size;
				totalFileCount ++;
			}
		});
		return {totalFileSize,totalFileCount};
	};



	
	
	render() {
		const {classes,settings} = this.props;
		const {uploadList,error_data,isSuccessUpload,errorType} = settings;

		const OkList = _.filter(uploadList,(item)=>{
			return _.includes(item.STATUS, 'OK');
		});
		
		const mainButtons = [
			{type:'BACK',func:this.handleClickBack,text:"一覧"}
		];


		let text;
		if(errorType === "FILE_DISABLED"){
			text =
				<span>
					以下のファイルが読み込めません<br/>ファイルの内容を確認してください<br/>
					{error_data.map((files,index)=>{
						return(
							<span key={index} style={{fontSize:"80%"}}>・{files}<br/></span>
						);
					})}
				</span>;
		}


		return (
			<div id="main_container">
				{(settings.isFetching) &&
				<Progress/>
				}
				{(settings.isUploading) &&
				<Progress
					subContents={<div className="progress_text">ファイルのアップロード中です。<br/>この処理には時間がかかる場合があります。</div>}
				/>
				}
				<SpNav history={this.props.history}/>
				<Header history={this.props.history}/>
				<article>
					<section className="title_area">
						<h2>荷受登録PDFアップロード</h2>
					</section>
					<p className={classes.cautionText}>
						※アップロードしたファイルが数百ページの場合、伝票マッチングに<strong>数時間</strong>かかる場合がございます。ご了承ください。
					</p>
					<section id="uploads" className="with_button">
						<Dropzone
							className={classNames("uploads_dropzone",{"is_over":this.state.dragging})}
							onDrop={this._handleDrop.bind(this)}
							onDragEnter={this._handleDragEnter.bind(this)}
							onDragLeave={this._handleDragLeave.bind(this)}
							onDragOver={this._handleDragOver.bind(this)}
							onDropAccepted={this._handleDropAccepted.bind(this)}
							onDropRejected={this._handleDropRejected.bind(this)}
							accept="application/pdf"
							maxSize={maxFileSize}
						>
							<div className="uploads_dropzone_inner">
								ここにファイルをドロップしてください。
								<span>※指定フォーマット以外のファイルは取りこめません</span>
							</div>
						</Dropzone>
						{uploadList.map((dt,index)=>{
							const file_size = getFileSize(dt.FILES.size);
							return (
								<div className="statusbar" key={index}>
									<div className="filename">{dt.FILES.name}</div>
									<div className="filesize">{file_size}</div>
									{
										(dt.STATUS === 'OK' &&
										<div className="progewssBar">
											<div>取込準備完了</div>
										</div>
										)
										||
										(dt.STATUS === 'ON_PROCESS' &&
										<div className="progewssBar">
											<div>処理中…</div>
										</div>
										)
										||
										(dt.STATUS === 'RECORD_NG' &&
										<div className="not_upload records" onClick={this.handleOpenErrorDisplay.bind(this,dt.ERROR_DET)}>{dt.MSG}</div>
										)
										||
										<div className="not_upload">{dt.MSG}</div>
									}
									<Button
										className={classNames('abort',classes.abortButton)}
										onClick={this._onClickDeleteFile.bind(this,dt.FILE_MANAGE_NO)}
									>
										取消
									</Button>
								</div>
							)
						})}
						{OkList.length > 0 &&
						<div id="import_btn" className="clearfix">
							<Button variant="contained" color="primary" size="large" id="btn_import" onClick={this.handleClickSave}>
								取込実行
							</Button>
						</div>
						}
					</section>
				</article>
				<MainButtons buttons={mainButtons}/>
				<Footer/>
				<AlertDialog
					open={this.state.dialogOpen}
					title={"確認"}
					text={<span>未取込みのファイルは破棄されます</span>}
					okFunction={this.handleDoAfterDialog}
					closeFunction={this.handleCancelDialog}
				/>
				<SuccessDialog
					open={isSuccessUpload}
					okFunction={this.handleCompleteProcess}
				/>
				<ErrorDialog
					open={this.props.settings.isProcessError}
					text={text}
				/>
				<ReloadModal />
				<LogoutModal />
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		navigation : state.navigation,
		auth: state.auth,
		settings : state.uploadReceiptNewSettings
	};
}
export default compose(
	withStyles(styles),
	connect(mapStateToProps)
)(UploadReceiptNew);




// WEBPACK FOOTER //
// ./src/routes/upload-receipt-new/index.js